import React from 'react';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
}

export default function Card({ children, className = '', style, onClick }: CardProps) {
  return (
    <div
      onClick={onClick}
      className={className}
      style={{
        background: 'var(--bg-default)',
        borderRadius: 'var(--radius-lg)',
        padding: '20px',
        border: '1px solid var(--border)',
        cursor: onClick ? 'pointer' : undefined,
        transition: 'transform 0.2s, border-color 0.2s',
        ...style,
      }}
    >
      {children}
    </div>
  );
}
